import tpl from './templates';

export const KVADROTSIKL = {
    make: tpl.make,
    city: tpl.city,
    body: tpl.body,

    city_make: tpl.makeCity,
    make_model: tpl.makeModel,
    city_isnew: tpl.cityIsnew,
    isnew_make: tpl.makeIsnew,
    body_make: tpl.makeBody,
    body_isnew: tpl.bodyIsnew,
    body_city: tpl.bodyCity,
    
    city_make_model: tpl.makeModelCity,
    isnew_make_model: tpl.makeModelIsnew,
    city_isnew_make: tpl.makeCityIsnew,
    body_make_model: tpl.makeModelBody,
    make_model_year: tpl.makeModelYear,
    body_isnew_make: tpl.isnewMakeBody,
    body_city_make: tpl.makeCityBody,
    body_city_isnew: tpl.isnewBodyCity,

    isnew_make_model_year: tpl.isnewMakeModelYear,
    city_isnew_make_model: tpl.isnewMakeModelCity,
    body_isnew_make_model: tpl.isnewMakeModelBody,
    body_city_make_model: tpl.makeModelCityBody,
    body_city_isnew_make: tpl.isnewMakeCityBody,

    body_city_isnew_make_model: tpl.isnewMakeModelCityBody,
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/search/kvadrotsikl/index.js